import { render, staticRenderFns } from "./departKpi.vue?vue&type=template&id=afc1241e&"
import script from "./departKpi.vue?vue&type=script&lang=js&"
export * from "./departKpi.vue?vue&type=script&lang=js&"
import style0 from "./departKpi.vue?vue&type=style&index=0&id=afc1241e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports